import {Component,  OnDestroy, OnInit, Inject} from '@angular/core';
import {News} from "../../model/models";
import {InformationService} from "../../services/information.service";
import {PageService} from "../../services/page.service";
import {Subject, takeUntil} from "rxjs";
import {environment} from "../../../environments/environment";
import {CookieService} from "ngx-cookie-service";

@Component({
  selector: 'country-choose',
  templateUrl: './country-choose.component.html',
  styleUrls: ['./country-choose.component.less']
})
export class CountryChooseComponent implements  OnInit  {

    countries: string[] = [];
    countryNames: any = {};
    countryUrls: any = {};
    selectedCountry: string;

  constructor(
    private informationService: InformationService,
    private pageService: PageService,
    private cookieService: CookieService,

  ) {
        this.countries = environment.countries;
        this.countryNames = environment.countryNames;
        this.countryUrls = environment.countryUrls;

  }

  ngOnInit(): void {
  }

  selectCountry() {

    this.cookieService.set("country", this.selectedCountry, 90);
    this.pageService.redirectCountryDns(this.selectedCountry);

  }


}
